import { put, takeLatest } from "@redux-saga/core/effects";
import { getLogAPI } from "redux/api/workflowLogAPI";
import { setShowLoadingScreen } from "redux/slices/global";
import {
  getActionLog,
  getActionLogSuccess,
  updateTotalLog,
} from "redux/slices/workflowLog";
export default function* actionLogSaga() {
  yield takeLatest(getActionLog.type, GetActionLogSaga);
}
function* GetActionLogSaga(action) {
  try {
    yield put(setShowLoadingScreen(true));
    const response = yield getLogAPI(action.payload);
    yield put(getActionLogSuccess(response.data.data.data));
    yield put(updateTotalLog(response.data.data.total));
    yield put(setShowLoadingScreen(false));
  } catch (error) {
    yield put(setShowLoadingScreen(false));
  }
}
